@charset "UTF-8";

/* app/js/src/components/clipping-studio/clipping-studio.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.root {
  display: flex;
  flex-direction: column;
  height: 100%;
  -webkit-user-select: none;
  user-select: none;
  position: relative;
}
.auto-reframe-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}
.auto-reframe-overlay evrideo-clipping-studio-auto-reframe-modal {
  width: 70%;
  max-width: 1400px;
  height: 90%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  min-height: 0;
  border-radius: 4px;
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.top-bar {
  flex-shrink: 0;
  background: rgb(255, 255, 255);
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
  padding: 1rem 1.5rem;
  position: relative;
  z-index: 50;
}
.top-bar__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top-bar__left {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
}
.top-bar__title {
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
  cursor: pointer;
  transition: color 0.15s ease;
  display: inline-block;
  width: fit-content;
}
.top-bar__title:hover {
  color: rgb(45, 187, 252);
}
.top-bar__title-input {
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  color: rgba(0, 0, 0, 0.85);
  background: transparent;
  border: none;
  border-bottom: 2px solid rgb(45, 187, 252);
  outline: none;
  padding: 0;
  display: inline-block;
  width: fit-content;
}
.top-bar__right {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.top-bar__undo-redo {
  display: flex;
  align-items: center;
  gap: 0;
}
.top-bar__undo-redo .top-bar__icon-btn {
  margin-right: 2px;
}
.top-bar__dropdown-wrap {
  background: rgb(235, 240, 244);
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.top-bar__dropdown-label {
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.54);
}
.top-bar__dropdown {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}
.top-bar__dropdown:disabled {
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.35);
}
.top-bar__divider {
  width: 1px;
  height: 2rem;
  background: rgba(0, 0, 0, 0.1);
  margin: 0 0.25rem;
}
.top-bar__icon-btn {
  padding: 0.5rem;
  color: rgba(0, 0, 0, 0.54);
  background: rgb(235, 240, 244);
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.top-bar__icon-btn:hover:not(:disabled) {
  color: rgba(0, 0, 0, 0.85);
  background: rgba(0, 0, 0, 0.04);
}
.top-bar__icon-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.top-bar__icon-btn svg {
  display: block;
}
.top-bar__status-actions {
  display: flex;
  align-items: center;
  gap: 2px;
}
.top-bar__save-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 4px;
  cursor: default;
  -webkit-user-select: none;
  user-select: none;
}
.top-bar__save-status svg {
  display: block;
}
.top-bar__save-status--saved {
  color: #61b965;
}
.top-bar__save-status--saving {
  color: #3b82f6;
}
.top-bar__save-status--error {
  color: #ef5350;
}
.top-bar__save-status-spinner {
  animation: top-bar-save-spin 0.8s linear infinite;
}
@keyframes top-bar-save-spin {
  to {
    transform: rotate(360deg);
  }
}
.top-bar__btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  background: rgb(235, 240, 244);
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.top-bar__btn:hover {
  background: rgba(0, 0, 0, 0.04);
}
.top-bar__btn svg {
  display: block;
  flex-shrink: 0;
}
.studio-layout {
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.left-column,
.right-column {
  flex-shrink: 0;
}
.center-column {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.thin-strip {
  width: 40px;
  min-width: 40px;
  height: 100%;
  background: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0;
  gap: 1rem;
}
.thin-strip.thin-strip-left {
  border-right: 1px solid #e2e8f1;
}
.thin-strip.thin-strip-right {
  border-left: 1px solid #e2e8f1;
  padding-top: 8px;
}
.thin-strip .expand-btn {
  padding: 0.5rem;
  color: #727d8b;
  background: transparent;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.thin-strip .expand-btn:hover {
  background: #f5f5f5;
}
.thin-strip .expand-btn svg {
  display: block;
}
.thin-strip.thin-strip-left .expand-btn svg.expand-btn__icon--mirror {
  transform: scaleX(-1);
}
.thin-strip.thin-strip-right .expand-btn svg.expand-btn__icon--mirror {
  transform: none;
}
.thin-strip .thin-strip-divider {
  width: 24px;
  height: 1px;
  background: #f5f5f5;
}
.thin-strip .thin-strip-label {
  font-size: 10px;
  font-weight: 700;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  white-space: nowrap;
}
.thin-strip-right .expand-btn {
  color: #1e88e5;
}
.thin-strip-right .expand-btn:hover {
  background: rgba(30, 136, 229, 0.08);
}
.thin-strip-right .expand-btn svg.expand-btn__icon--mirror {
  transform: none;
}
.root main {
  display: flex;
  flex-grow: 1;
  min-height: 0;
}
.root main .video-player {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.1);
  border-width: 0 1px;
}
.root main .video-player .controls {
  flex: 0 0 auto;
  padding: 0 13px;
  display: flex;
  background: rgb(235, 240, 244);
  width: 100%;
  justify-content: space-between;
  align-items: center;
  min-height: 44px;
  gap: 12px;
}
.root main .video-player .controls .control-button {
  background: rgb(35, 47, 58);
  display: flex;
  flex-direction: row;
  gap: 12px;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
  align-items: center;
  justify-content: space-evenly;
  flex-shrink: 0;
  width: max-content;
  padding: 2px 5px;
  height: 24px;
  min-width: 30px;
  border-radius: 0;
}
.root main .video-player .controls .control-button.active {
  background: rgb(45, 187, 252);
}
.root main .video-player .controls .control-button span {
  color: rgb(255, 255, 255);
  text-align: center;
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  text-transform: uppercase;
}
.root main .video-player .controls .control-button span.bracket {
  font-size: 18px;
  line-height: 1;
}
.root main .video-player .controls > div {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}
.root main .video-player .stream-mode-switch {
  flex: 0 0 auto;
  display: flex;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 0;
  padding: 2px;
  gap: 2px;
}
.root main .video-player .stream-mode-switch .stream-mode-option {
  height: 25px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: rgb(114, 125, 139);
  background: transparent;
}
.root main .video-player .stream-mode-switch .stream-mode-option.active {
  background: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
}
.root main .video-player .stream-mode-switch .stream-mode-option.disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}
.root main .video-player .time-nav {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
}
.root main .video-player .controls-divider {
  width: 1px;
  height: 24px;
  background: rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}
.root main .video-player .rewind-wrap {
  position: relative;
}
.root main .video-player .rewind-popover {
  position: absolute;
  left: 0;
  bottom: calc(100% + 6px);
  display: flex;
  flex-direction: row;
  gap: 4px;
  padding: 6px;
  background: rgb(255, 255, 255);
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.08);
  z-index: 100;
}
.root main .video-player .rewind-popover__btn {
  height: 32px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #232f3a;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.root main .video-player .rewind-popover__btn:hover {
  background: rgba(0, 0, 0, 0.06);
}
.root main .video-player .live-btn {
  height: 32px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background: rgb(255, 76, 81);
  color: rgb(255, 255, 255);
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition: background 0.15s ease;
}
.root main .video-player .live-btn:hover {
  background: rgb(224, 67, 71);
}
.root main .video-player .jump-btn {
  height: 32px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 0;
  cursor: pointer;
  background: transparent;
  color: rgb(35, 47, 58);
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 12px;
  font-weight: 700;
  transition: background 0.15s ease;
}
.root main .video-player .jump-btn:hover {
  background: rgba(0, 0, 0, 0.04);
}
.root main .video-player .icon-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 0;
  cursor: pointer;
  background: transparent;
  color: rgb(35, 47, 58);
  transition: background 0.15s ease, color 0.15s ease;
}
.root main .video-player .icon-btn:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.04);
}
.root main .video-player .icon-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.root main .video-player .icon-btn.active {
  background: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
}
.root main .video-player .icon-btn svg {
  width: 16px;
  height: 16px;
}
.root main .video-player .timecode-clock {
  min-width: 100px;
  height: 32px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 0;
  background: rgb(255, 255, 255);
  font-family:
    "Open Sans",
    sans-serif,
    monospace;
  font-size: 12px;
  font-weight: 600;
  color: rgb(35, 47, 58);
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.05);
}
.root main .video-player .video-controls {
  flex-grow: 1;
  justify-content: center;
}
.root main .video-player .zoom-controls {
  flex: 0 0 auto;
}
.root main .video-player .cc-control {
  flex: 0 0 auto;
}
.root main .video-player .cc-btn {
  height: 24px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 0;
  cursor: pointer;
  background: rgb(35, 47, 58);
  color: rgb(255, 255, 255);
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 12px;
  font-weight: 700;
  transition: background 0.15s ease;
}
.root main .video-player .cc-btn:hover {
  background: rgb(45, 187, 252);
}
.root main .video-player .cc-btn.active {
  background: rgb(45, 187, 252);
}
/*# sourceMappingURL=clipping-studio.component.css.map */
